import React from "react";
import "./Action.css";

const Action = () => {
  return (
    <section className="action" id="action">
      <div className="action-content">
        <h1>ÁREA DE ATUAÇÃO</h1>

        <div className="action-right">
          <h2>Direito do Trabalho</h2>
          <h3>
            O Direito do Trabalho é o ramo jurídico que regula as relações entre
            empregados e empregadores, assegurando direitos e deveres previstos
            na legislação trabalhista. Atua na prevenção e solução de conflitos
            relacionados a vínculo empregatício, verbas rescisórias, jornada de
            trabalho, horas extras, férias, assédio, estabilidade, acordos e
            demais questões decorrentes da relação laboral. A atuação é pautada
            na orientação estratégica e na defesa dos interesses do cliente,
            tanto na esfera consultiva quanto contenciosa, sempre com foco na
            segurança jurídica e no cumprimento da lei.
          </h3>
        </div>
      </div>
    </section>
  );
};

export default Action;
